export const dialogBackdropMotionProps = {
  _open: {
    animationName: "fade-in",
    animationDuration: "160ms",
  },
  _closed: {
    animationName: "fade-out",
    animationDuration: "120ms",
  },
  animationTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
  animationFillMode: "both",
} as const;

export const dialogContentMotionProps = {
  _open: {
    animationName: "scale-in, fade-in",
    animationDuration: "190ms",
  },
  _closed: {
    animationName: "scale-out, fade-out",
    animationDuration: "140ms",
  },
  animationTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
  animationFillMode: "both",
  transformOrigin: "center center",
  willChange: "opacity, transform",
} as const;
